import type { StatusChange } from 'app/types/list-memberships'
import type { SystemListStatusField } from 'app/types/navigation'
import { logWarn } from 'lib/logging'

type StatusActivity = {
  id?: string | null
  activityDate?: string | null
  createdDate?: string | null
  source?: string | null
  data?: unknown
  description?: string | null
}

type FieldChange = { from?: unknown; to?: unknown }

function changeData(activity: StatusActivity): Record<string, FieldChange> | undefined {
  if (activity.data && typeof activity.data === `object`) return activity.data as Record<string, FieldChange>
  if (!activity.description) return undefined
  try {
    const parsed: unknown = JSON.parse(activity.description)
    return parsed && typeof parsed === `object` ? (parsed as Record<string, FieldChange>) : undefined
  } catch (error) {
    logWarn(`skipped a status activity with unreadable change data`, activity.id, error)
    return undefined
  }
}

export function statusChanges(activities: readonly StatusActivity[], field: SystemListStatusField): StatusChange[] {
  // Ordered by when the change was recorded: writers disagree on whether activityDate is wall clock or UTC.
  return activities
    .flatMap((activity): { recordedAt: string; change: StatusChange }[] => {
      const change = changeData(activity)?.[field]
      if (!change || !activity.activityDate) return []
      return [
        {
          recordedAt: activity.createdDate ?? activity.activityDate,
          change: {
            id: activity.id ?? activity.activityDate,
            at: activity.activityDate,
            from: change.from == null ? undefined : String(change.from),
            to: change.to == null ? undefined : String(change.to),
            source: activity.source ?? undefined,
          },
        },
      ]
    })
    .sort((a, b) => b.recordedAt.localeCompare(a.recordedAt))
    .map(({ change }) => change)
}
